import React, { useEffect } from "react";
import { useNavigate, Outlet, useLocation } from "react-router-dom";
import InfoSection from "../../components/auth/InfoSection";
import "./index.scss";
import EasySupport from "../../components/easySupport";
import { storageService } from "../../services/storageService";

const Authlayout: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/auth/profile-setting") return;

    const accessToken = storageService.getAccessToken();
    const refreshToken = storageService.getRefreshToken();

    if (accessToken || refreshToken) {
      navigate("/");
    }
  }, [navigate, location.pathname]);

  return (
    <div className="login-page-container">
      <EasySupport />
      <div className="left-side">
        {/* {pathname !== "/auth/login" && (
          <ArrowLeftOutlined
            className="back-icon"
            onClick={() => navigate(-1)}
          />
        )}

        <Space className="auth-header" direction="vertical">
          <Text className="welcome-text">Welcome to</Text>
          <Title className="efone-title">
            <span>e</span>Fone
          </Title>
        </Space> */}

        <Outlet />
      </div>

      <InfoSection />
    </div>
  );
};

export default Authlayout;
